<ng-scrollbar visibility="hover">
  <div class="d-flex flex-column ps-4 pe-4 pt-4 pb-5">
    <h1>{{ 'billBoard.title' | translate }}</h1>
    <br>
    <br>
    <div class="d-flex card-wrapper">
      <mat-accordion [multi]="true" displayMode="flat" class="accordion-container">
        <mat-expansion-panel [disabled]="generalFiles.length === 0 && !(roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)" [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'billBoard.general' | translate}} ({{generalFiles.length}})
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-upload
            *ngIf="(roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)"
            [uploadLocation]="UploadLocation.BILLBOARDGENERAL"
            class="w-100"></app-upload>
          <app-download-files [attachedFiles]="generalFiles" [inBillBoard]="true"></app-download-files>
        </mat-expansion-panel>
        <mat-expansion-panel [disabled]="generalMeetingsFiles.length === 0 && !(roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)" [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'billBoard.generalMeetings' | translate}} ({{generalMeetingsFiles.length}})
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-upload
            *ngIf="(roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)"
            [uploadLocation]="UploadLocation.BILLBOARDGENERALMEETINGS"
            class="w-50"></app-upload>
          <app-download-files [attachedFiles]="generalMeetingsFiles"></app-download-files>
        </mat-expansion-panel>
        <mat-expansion-panel [disabled]="authorisationsFiles.length === 0 && !(roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)" [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'billBoard.authorisations' | translate}} ({{authorisationsFiles.length}})
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-upload
            *ngIf="(roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)"
            [uploadLocation]="UploadLocation.BILLBOARDAUTHORISATIONS"
            class="w-50"></app-upload>
          <app-download-files [attachedFiles]="authorisationsFiles" [inBillBoard]="true"></app-download-files>
        </mat-expansion-panel>
        <mat-expansion-panel [disabled]="applicationsFiles.length === 0 && !(roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)" [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'billBoard.applications' | translate}} ({{applicationsFiles.length}})
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-upload
            *ngIf="(roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)"
            [uploadLocation]="UploadLocation.BILLBOARDAPPLICATIONS"
            (updateAttachedFilesInParent)="newFiles = $event"
            class="w-50">
          </app-upload>
          <div *ngIf="(roles$ | async).includes(Roles.ROLE_ASSOCIATION_ADMIN)" class="flex-column flex-wrap d-flex w-100">
            <div class="d-flex justify-content-between w-100 mb-3">
              <input type="radio" name="emailType" [(ngModel)]="selectedOption" [value]="'membership'" class="mt-4 me-3">
              <div [class.disabled]="selectedOption !== 'membership'"  class="d-flex justify-content-start w-100">          
                <app-input-field class="field-container mb-0 me-3 w-50"
                                 [label]="'billBoard.companyName'|translate">
                  <input name="companyName"
                         [(ngModel)]="companyName"
                         class="input"
                         [disabled]="selectedOption !== 'membership'">
                </app-input-field>
                <app-input-field class="field-container mb-0 me-3 w-25"
                                 [label]="'billBoard.companyLocation'|translate">
                  <input name="companyLocation"
                         [(ngModel)]="companyLocation"
                         class="input"
                         [disabled]="selectedOption !== 'membership'">
                </app-input-field>
                <button class="blue-border" [disabled]="selectedOption !== 'membership' || !(companyName && companyLocation && hasOneNewApplicationFile())"
                        (click)="sendMembershipEmail()">
                  <img class="icon" src="assets/svg-icons/profile-user/send.svg" alt="">
                  {{ 'billBoard.sendEmail' | translate }}
                </button>
              </div>  
            </div>
            <!-- Exchange Visitor Email Section -->
            <div class="d-flex justify-content-between w-100 mb-3">
              <input type="radio" name="emailType" [(ngModel)]="selectedOption" [value]="'exchangeVisitor'" class="mt-4 me-3">
              <div [class.disabled]="selectedOption !== 'exchangeVisitor'" class="d-flex justify-content-start w-100">
                <app-input-field class="field-container mb-0 me-3 w-50" [label]="'billBoard.companyName' | translate">
                  <input name="companyName" [(ngModel)]="companyName" class="input" [disabled]="selectedOption !== 'exchangeVisitor'">
                </app-input-field>
                <app-input-field class="field-container mb-0 me-3 w-25" [label]="'billBoard.exchangeVisitorName' | translate">
                  <input name="exchangeVisitorName" [(ngModel)]="exchangeVisitorName" class="input" [disabled]="selectedOption !== 'exchangeVisitor'">
                </app-input-field>
                <button class="blue-border"
                        [disabled]="selectedOption !== 'exchangeVisitor' || !(companyName && exchangeVisitorName && hasOneNewApplicationFile())"
                        (click)="sendExchangeVisitorEmail()">
                  <img class="icon" src="assets/svg-icons/profile-user/send.svg" alt="">
                  {{ 'billBoard.sendEmail' | translate }}
                </button>
              </div>
            </div>
          </div>


          <hr *ngIf="(roles$ | async).includes(Roles.ROLE_ASSOCIATION_ADMIN)" class="mt-1 mb-1">

          <app-download-files [attachedFiles]="applicationsFiles" [inBillBoard]="true"></app-download-files>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

</ng-scrollbar>





